import { useState } from 'react';
import { Box, IconButton } from '@chakra-ui/react';
import { MdOutlineMenu } from 'react-icons/md';
import { Container } from '../layout';
import Logo from '../logo';
import { MainMenu, SideMenu } from './main-menu';
import Actions from './actions';
import { Desktop, Mobile } from '../visual';
import { useOnlyClient } from '@/hooks/use-only-client';

function Header() {
  const [sidemenuOpen, setSidemenuOpen] = useState(false);
  const render = useOnlyClient();
  return (
    <header>
      <Container
        display={'flex'}
        alignItems={'center'}
        pt={'20px'}
        boxSizing="content-box"
      >
        <Desktop>
          <Logo />
          <Box mr={'56px'} />
          <MainMenu />
        </Desktop>
        <Mobile>
          <IconButton
            aria-label="menu icon"
            onClick={() => setSidemenuOpen(true)}
            variant={'ghost'}
            rounded={'full'}
            fontSize={'3xl'}
          >
            <MdOutlineMenu />
          </IconButton>
          <SideMenu
            open={sidemenuOpen}
            onClose={() => setSidemenuOpen(false)}
          />
        </Mobile>
        {render && <Actions />}
      </Container>
    </header>
  );
}

export default Header;
